module.exports = __webpack_public_path__ + "72fa56db852e.2e49652.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/72fa56db852e.png
// module id = vg9U
// module chunks = 1